import { SVGProps } from 'react';

export const Database = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 8.09212V7.00012C10.5 6.17312 9.827 5.50012 9 5.50012H6.5V4.00012H9.5C9.776 4.00012 10 3.77612 10 3.50012V1.50012C10 1.22412 9.776 1.00012 9.5 1.00012H2.5C2.224 1.00012 2 1.22412 2 1.50012V3.50012C2 3.77612 2.224 4.00012 2.5 4.00012H5.5V5.50012H3C2.173 5.50012 1.5 6.17312 1.5 7.00012V8.09212C0.919 8.29912 0.5 8.84912 0.5 9.50012C0.5 10.3271 1.173 11.0001 2 11.0001C2.827 11.0001 3.5 10.3271 3.5 9.50012C3.5 8.84912 3.081 8.29912 2.5 8.09212V7.00012C2.5 6.72462 2.7245 6.50012 3 6.50012H5.5V8.09212C4.919 8.29912 4.5 8.84912 4.5 9.50012C4.5 10.3271 5.173 11.0001 6 11.0001C6.827 11.0001 7.5 10.3271 7.5 9.50012C7.5 8.84912 7.081 8.29912 6.5 8.09212V6.50012H9C9.2755 6.50012 9.5 6.72462 9.5 7.00012V8.09212C8.919 8.29912 8.5 8.84912 8.5 9.50012C8.5 10.3271 9.173 11.0001 10 11.0001C10.827 11.0001 11.5 10.3271 11.5 9.50012C11.5 8.84912 11.081 8.29912 10.5 8.09212Z"
      fill="currentColor"
    />
  </svg>
);
